module.exports = __webpack_public_path__ + "img/switch_img2.6273644a.png";